/// <amd-module name="typeahead/features/NearbyAirportParamModifier" />

import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [{
    lobs: ["FLIGHTS"],
}];

// This feature is turned on in general. It is turned off off for specific client(s) to assist an investigation.
// For details of that investigation, see:
// https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4368
//
// Should opting out of features becomes permenantly useful, it should be implemented through the suggestionPicker
// tag. The task is tracked with https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4192 .
const inapplicableClients: string[] = ["Flights.Search"];

const featureFlag: string = "nearby_airport";

export class NearbyAirportParamModifier implements IRequestUrlParamModifier {
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
            JQueryPromise<ISuggestServiceQueryParams> {
        if (inapplicableClients.lastIndexOf(context.clientId) < 0) {
            return addFeatureFlag(featureFlag, configuration, params, context, options);
        } else {
            let deferred: JQueryDeferred<ISuggestServiceQueryParams> = $.Deferred();
            return deferred.resolve(params).promise();
        }
    }
}
